import React from 'react';
import {
	Card,
	CardActions,
	CardContent,
} from "@material-ui/core";
import classNames from 'classnames';
import { ReactComponent as Like } from "../../../assets/Like.svg";
import { ReactComponent as Comment } from "../../../assets/Comment.svg";
import { TPost } from '../../../../types/Post';
import { SvgIcon } from '@material-ui/core';
import s from './Post.module.scss';
import TopAvatarTime from './TopAvatarTime/TopAvatarTime';
import { PostContent } from './PostContent';
import { openWidgetPost, modifyPost } from '../../../lib/widget-loader';
import { canProceedToModifyPost } from '../../../helper/modify-post-starting-check';

export const Post = ({ post,
	isFunFacts,
	socialRepost,
	cdnRoot }: {
		cdnRoot: string, post: TPost,
		socialRepost?: boolean
		isFunFacts?: boolean
	}): React.ReactElement => {
	const cardActionIcons = [
		{
			component: Like,
			value: post.likes || 0,
			isLike: true,
		},
		{
			component: Comment,
			value: post.comments?.count || 0,
		},
	]
	const metricsFields = [
		{
			title: 'Likes',
			property: post.likes,
		},
		{
			title: 'Comments',
			property: post.comments?.count,
		},
		{
			title: 'Product Taps',
			property: post.seeProduct,
		},
		{
			title: 'Reaction Taps',
			property: post.seeComments,
		},
		{
			title: 'Referrals',
			property: post.seeStory,
		},
		post.type === 'pollPost' ? {
			title: 'Votes',
			property: (post && post.item1 ? post.item1?.votes : 0) + (post && post.item2 ? post.item2?.votes : 0),
		} : null,
	]
	return (
		<Card className={`${classNames(s.root)} card-root`}
			elevation={0}
			onClick={socialRepost ? () => { return '' } : () => openWidgetPost(post._id)}
			style={{ height: 'auto', cursor: socialRepost ? '' : 'pointer' }}
		>
			<div>
				<TopAvatarTime post={post} socialRepost={socialRepost} />
				<h3 color="textPrimary" className='post-title'>
					{post.text}
				</h3>
			</div>
			{PostContent(post, cdnRoot)}
			<div>
				{socialRepost && canProceedToModifyPost(post) &&
					<>
						<div
							onClick={socialRepost ? () => modifyPost(post._id) : () => openWidgetPost(post._id)}
							className='tag-product'>Tag products</div>
						<CardActions style={{ padding: '0', marginTop: '13px' }}>
							{cardActionIcons.map((action, index) => <React.Fragment key={index}>
								<SvgIcon style={action.isLike ? { width: '20px', height: '20px', margin: 0, } : { margin: 0, }} component={action.component} />
								<h3 color="textPrimary" className='products-actions'>
									{action.value}
								</h3>
							</React.Fragment>)}
						</CardActions>
					</>
				}
				{isFunFacts &&
					<CardContent style={{ padding: '0' }}>
						<div>overview: {post.totalSee}</div>
						{metricsFields.map(metric =>
							metric &&
							<div key={metric.title}>
								{metric.title}:	{metric.property || 0}{ }
							</div>
						)}
					</CardContent>
				}
			</div>
		</Card >
	);
};